export const DeviceTypes = {
    Button: 'Sage Button',
    DoorAlarm: 'Door Alarm',
    FallDetectionDevice: 'Fall Detection Device',
    M3: 'Melten M3 Device',
    UniversalTransmitter: 'Universal Transmitter',
    MovementSensor: 'Movement Sensor',
} as const;

export type DeviceType = (typeof DeviceTypes)[keyof typeof DeviceTypes];

export const DeviceTypeLabels = {
    [DeviceTypes.Button]: 'Button',
    [DeviceTypes.DoorAlarm]: 'Door Sensor',
    [DeviceTypes.FallDetectionDevice]: 'Fall Detection Device',
    [DeviceTypes.M3]: 'Melten M3 Device',
    [DeviceTypes.UniversalTransmitter]: 'Universal Transmitter',
    [DeviceTypes.MovementSensor]: 'Check-in Sensor',
};
